import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './FJSearchAutoComplete.module.less';
import FJTransverse from './FJTransverse';
import ReactDOM from 'react-dom';
import FJVerticalScroller from '../FJScroller/FJVerticalScroller';

class FJSearchAutoComplete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: -1,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (JSON.stringify(this.props.completeList) !== JSON.stringify(prevProps.completeList)) {
            this.init();
        }
    }

    init = () => {
        this.setState({
            activeIndex: -1,
        });
        this._scroll.scrollTop(0);
    };

    /**
     * @description 渲染列表
     * @private
     */
    _getListComp = () => {
        let { completeList, onSearch } = this.props;
        return completeList.map((item, index) => (
            <FJTransverse
                key={index + item}
                keyword={item}
                onClick={() => {
                    onSearch(item);
                }}
                ref={ele => (this['machItem' + index] = ele)}
                active={this.state.activeIndex === index}
                onMouseEnter={() => {
                    this._onMouseEnter(index);
                }}
            />
        ));
    };

    _onMouseEnter = index => {
        this.setState({ activeIndex: index });
    };

    /**
     * @desc 设置index - 1
     */
    reduceIndex = () => {
        let list = this.props.completeList;
        if (list.length === 0) {
            return;
        }
        let activeIndex = this.state.activeIndex;
        if (activeIndex === 0) {
            activeIndex = list.length - 1;
        } else {
            activeIndex = activeIndex - 1;
        }
        this.setState({ activeIndex: activeIndex });

        this.props.moveUpOrDown && this.props.moveUpOrDown(list[activeIndex]);

        let topIndex = activeIndex - 4;
        if (topIndex < 0) topIndex = 0;
        let refName = 'machItem' + topIndex;

        const node = ReactDOM.findDOMNode(this[refName]);
        if (node) {
            this._scroll.scrollTop(node.offsetTop);
        }
    };

    /**
     * @desc 设置index + 1
     */
    addIndex = () => {
        let list = this.props.completeList;
        if (list.length === 0) {
            return;
        }
        let activeIndex = this.state.activeIndex;
        if (activeIndex === list.length - 1) {
            activeIndex = 0;
        } else {
            activeIndex = activeIndex + 1;
        }
        this.setState({ activeIndex: activeIndex });
        this.props.moveUpOrDown && this.props.moveUpOrDown(list[activeIndex]);

        let topIndex = activeIndex - 4;
        if (topIndex < 0) topIndex = 0;
        let refName = 'machItem' + topIndex;

        const node = ReactDOM.findDOMNode(this[refName]);
        if (node) {
            this._scroll.scrollTop(node.offsetTop);
        }
    };

    render() {
        let { style, active, completeList, maxHeight } = this.props;
        let height;

        if (completeList.length > 10) {
            height = 36 * 10 + 20;
        } else {
            height = 36 * completeList.length + 20 + 2;
        }
        height = Math.min(height, maxHeight);

        return (
            <div
                className={classNames(styles.box, active ? styles.active : '')}
                style={{ ...style, height: height + 'px', top: style.top + 4 }}
            >
                <FJVerticalScroller
                    style={{ height: '100%' }}
                    onMouseDown={e => {
                        e.preventDefault();
                    }}
                    ref={ele => (this._scroll = ele)}
                >
                    <div className={styles.inner}>{this._getListComp()}</div>
                </FJVerticalScroller>
            </div>
        );
    }
}

export default FJSearchAutoComplete;
